<template>
  <div class="sex-selector">
    <div
      class="selection"
      :class="{ 'selection--selected': checkIfIsSelected('general.women') }"
      @click="handleClick('general.women')"
    >
      <div class="emoji-container">
        <p class="emoji">{{ "women" | emoji }}</p>
      </div>
      <p class="emoji-text">
        {{ "general.women_cool" | translate | capitalize }}
      </p>
    </div>
    <div
      class="selection"
      :class="{ 'selection--selected': checkIfIsSelected('general.men') }"
      @click="handleClick('general.men')"
    >
      <div class="emoji-container">
        <p class="emoji">{{ "men" | emoji }}</p>
      </div>
      <p class="emoji-text">
        {{ "general.men_cool" | translate | capitalize }}
      </p>
    </div>
  </div></template
>

<script>
import { sexNavigation } from "../../mixins";

export default {
  name: "sex-selector",
  mixins: [sexNavigation],
  props: {
    isNavigation: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      optional: true
    }
  },
  methods: {
    handleClick(string) {
      this.isNavigation
        ? this.changeSex(this.$t(string))
        : this.$emit("input", string);
    },
    checkIfIsSelected(string) {
      return this.isNavigation
        ? this.isSelected(this.$t(string))
        : `general.${this.value}` === string;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.sex-selector {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.selection {
  width: 45%;
  height: 100%;
  border-radius: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: $gyra-grey-lightest;
  cursor: pointer;
  position: relative;

  &:first-child::after {
    content: "";
    border-right: 1px solid;
    height: 80%;
    position: absolute;
    right: -10px;
  }
}

.emoji-container {
  margin-right: 5px;
  background-color: white;
  border-radius: 100px;
  height: 28px;
  width: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 2px;
}
.emoji {
  margin-bottom: 0;
}
.selection--selected {
  background-color: $gyra-salmon;
}
.emoji-text {
  font-weight: bold;
  font-size: 11px;
  margin-bottom: 0;
}
</style>
